import type { ChangeMySommelierResultDto, ConfirmEmailDto, CreateClientUserDto, MySommelierDto } from './models';
import { RestService, Rest } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import type { PickUpDto } from '../pick-ups/models';
import type { IdentityUserDto } from '../volo/abp/identity/models';

@Injectable({
  providedIn: 'root',
})
export class ClientService {
  apiName = 'Default';


  confirmEmail = (input: ConfirmEmailDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: '/api/app/client/confirm-email',
      body: input,
    },
    { apiName: this.apiName,...config });


  createClientUser = (input: CreateClientUserDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, IdentityUserDto>({
      method: 'POST',
      url: '/api/app/client/client-user',
      body: input,
    },
    { apiName: this.apiName,...config });


  getPickUpsBySommelier = (slug: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PickUpDto[]>({
      method: 'GET',
      url: '/api/app/client/pick-ups-by-sommelier',
      params: { slug },
    },
    { apiName: this.apiName,...config });


  getSommelierSlug = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, string>({
      method: 'GET',
      responseType: 'text',
      url: '/api/app/client/sommelier-slug',
    },
    { apiName: this.apiName,...config });


  // winepassport#338 / CU-43 — "Mi Sommelier"
  getMySommelier = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, MySommelierDto>({
      method: 'GET',
      url: '/api/app/client/my-sommelier',
    },
    { apiName: this.apiName,...config });


  changeMySommelier = (sommelierId: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, ChangeMySommelierResultDto>({
      method: 'POST',
      url: `/api/app/client/change-my-sommelier/${sommelierId}`,
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
